// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"style__materialize-textarea___3Txp1","modal-2463794813":"style__modal-2463794813___PYcCL","container":"style__container___2SWAE","activeClass":"style__activeClass___bJDwH","removePadding":"style__removePadding___HckqG","buttonContainer":"style__buttonContainer___1oDLa","dummyContainer":"style__dummyContainer___HPB00","tabViews":"style__tabViews___129Vz","loginContainer":"style__loginContainer___2-4kj","addPadding":"style__addPadding___12p3P"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Admin/components/StudentView/style.scss
// module id = 1565
// module chunks = 0